import Image from 'next/image'
import React from 'react'

import Button from '@/shared/components/button/Button'
import { Text } from '@/shared/components/typography'

const PurchaseInComplete = ({ isInComplete, onClick }: { isInComplete: boolean; onClick: () => void }) => {
  if (!isInComplete) return null
  return (
    <div className="absolute left-0 top-0 flex h-full w-full flex-1 flex-col bg-010">
      <div className="mb-9 flex w-full flex-1 flex-col items-center justify-center gap-3">
        <Text level="text1" color="text090" weight="bold">
          결제가 완료되지 않았습니다.
        </Text>
        <Text level="text2" color="text090">
          다시 결제를 진행해주세요.
        </Text>
        <Image
          src="/images/light_img_payfailed.png"
          alt="결제미완료"
          width={0}
          height={0}
          style={{ width: '70%', height: 'auto' }}
        />
      </div>
      <div className="sticky bottom-0 px-4 pb-3">
        <Button text="다시 결제하기" color="text010" background="bg030" disabled={false} onClick={onClick} />
      </div>
    </div>
  )
}

export default PurchaseInComplete
